export default "__VITE_ASSET__Buc64tgw__"